var InsertPasswordModule = /** @class */ (function () {
    function InsertPasswordModule() {
    }
    return InsertPasswordModule;
}());
export { InsertPasswordModule };
